import { configureStore } from '@reduxjs/toolkit';
import systemSlice from './reducers/systemSlice';
import siteListSlice from './reducers/siteListSlice';
import queueSlice  from './reducers/queueSlice';
import pickupSlice  from './reducers/pickupSlice';
import ticketSlice  from './reducers/ticketSlice';
import siteSlice from './reducers/siteSlice';
import reservationSlice from './reducers/reservationSlice';
import tvSlice from './reducers/tvSlice';

export default configureStore({
  reducer: {
    system: systemSlice,
    siteList: siteListSlice,
    site: siteSlice,
    queue: queueSlice,
    pickup: pickupSlice,
    ticket: ticketSlice,
    reservation: reservationSlice,
    tv: tvSlice
  }
})